import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EcommerceCommonUISharedModule } from './extensions/3c85c48b4cdc1012b218fdaf37bb540b650116e12e560bfe88e79dc60922f4af/ecommerce-common-ui-shared.module';
import { EcommerceCommonPipeSharedModule } from './extensions/3c85c48b4cdc1012b218fdaf37bb540b650116e12e560bfe88e79dc60922f4af/ecommerce-common-pipe-shared.module';
import { AfterSaleUiSharedModule } from './extensions/ac7e338a92246c4e298742344bb4f67d9e5ee41bf15310cd2c1b13af73d69898/after-sale-ui-shared.module';


@NgModule({
    imports: [CommonModule, EcommerceCommonUISharedModule, EcommerceCommonPipeSharedModule, AfterSaleUiSharedModule],
})
export class SharedExtensionsModule {}
